import React from 'react';
import ServicePage from '../../components/site/ServicePage';
import LiveDemoSection from '../../components/site/LiveDemoSection';
import { PHONE_FAQS as FAQS } from '../../site/faqs';

export default function PhoneAgent() {
  return (
    <ServicePage
      path="/phone-agent"
      eyebrow="AI phone agent"
      title="Every call answered. Every customer known."
      lead="Keep your number. The agent answers knowing your whole floor and every order. When a person is needed, it transfers to your staff."
      proof={{ label: 'Try it live, below', href: '#live-demo' }}
      features={[
        { title: 'Recognizes the caller', text: 'A returning customer’s receipt is in front of it before the first word.' },
        { title: 'Sells to new callers', text: 'Prices, sizes, photos, what fits a budget, and current deals.' },
        { title: 'Texts mid-call', text: 'A photo or the flyer lands on the caller’s phone during the call.' },
        { title: 'Transfers on your schedule', text: 'Only staff on shift get the transfer.' },
        { title: 'English, Spanish, Arabic', text: 'It switches language when the caller does.' },
        { title: 'Every call recapped', text: 'A summary texted to your team, with the lead and the budget saved.' },
      ]}
      customer={{
        title: 'What your caller gets',
        items: [
          { title: 'An answer on the first ring', text: 'At 9 pm, on Sunday, and during the rush.' },
          { title: 'Their order, not a hold queue', text: '"Where is my sectional" is answered from the receipt.' },
          { title: 'A real person when it matters', text: 'Ask for someone and the call transfers with the context.' },
        ],
      }}
      steps={[
        { title: 'Forward your number', text: 'One setting with your carrier.' },
        { title: 'We load the catalog and the hours', text: 'Your brands, prices, deals, policies, and who is on shift when.' },
        { title: 'Read the first recaps', text: 'Every call comes back as a text to your team.' },
      ]}
      faqs={FAQS}
      closing={{ title: 'Hear it answer a call.', text: 'Try the demo above, or book 30 minutes.' }}
    >
      <LiveDemoSection />
    </ServicePage>
  );
}
